import { ISolicitudAdicionarInfoModel } from "../interfaces/solicitud/ISolicitudAdicionarInfoModel";

export class SolicitudAdicionarInfoModel implements ISolicitudAdicionarInfoModel {
    idSolicitud : number;
    comentarios: string;

    constructor(){
        this.idSolicitud = 0;
        this.comentarios = '';
    }
}
